// extracted by mini-css-extract-plugin
export default {"Container":"EmailLoader_Container__6+MIc","Header":"EmailLoader_Header__zD6+2","HeaderContent":"EmailLoader_HeaderContent__kOxBW","BodyContainer":"EmailLoader_BodyContainer__dQVFQ"};